import { render, staticRenderFns } from "./SDADialogs.vue?vue&type=template&id=40796edc"
import script from "./SDADialogs.vue?vue&type=script&lang=js"
export * from "./SDADialogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports